import { Component, OnInit } from '@angular/core';
import { ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { FormlyDropdownValue } from '@intellio/shared/models';
import { FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { FieldType, FormlyFieldProps } from '@ngx-formly/material/form-field';

@Component({
  selector: 'itc-formly-field-meter-collar-select',
  template: `
    <mat-select
      [id]="id"
      [formControl]="control"
      [formlyAttributes]="field"
      [required]="props.required"
      [placeholder]="props.placeholder"
      [tabIndex]="props.tabindex"
      [errorStateMatcher]="errorStateMatcher"
    >
      @for (option of meterCollarOptions; track option) {
        <mat-option [value]="option.value" [disabled]="option.disabled">
          <span class="meter-collar-option__model">{{
            option.displayLabel || option.value
          }}</span>
          @if (option.displayMetadata?.length) {
            <span class="meter-collar-option__meta">
              | {{ getDisplayMetadata(option) }}
            </span>
          }
        </mat-option>
      }
    </mat-select>
  `,
  styles: [
    `
      .meter-collar-option__meta {
        color: var(--mat-select-placeholder-text-color, rgba(0, 0, 0, 0.54));
      }
    `,
  ],
  imports: [
    FormlyModule,
    MatOptionModule,
    MatSelectModule,
    ReactiveFormsModule,
  ],
})
export class MeterCollarSelectComponent
  extends FieldType<FieldTypeConfig<FormlyFieldProps>>
  implements OnInit
{
  control: UntypedFormControl;

  get meterCollarOptions(): FormlyDropdownValue[] {
    return (this.props.options ?? []) as FormlyDropdownValue[];
  }

  getDisplayMetadata(option: FormlyDropdownValue): string {
    return (option.displayMetadata ?? []).join(' | ');
  }

  ngOnInit() {
    this.control = this.formControl as UntypedFormControl;
  }
}
